import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createShipFrom: {
    defaultMessage: '+ Create Ship From',
    id: 'pNSxbn',
    description: 'Default text in a dropdown item which allows the user to create a warehouse/ship from location.',
  },
  shipFromDropdownDefaultText: {
    defaultMessage: 'Select Ship From',
    id: 'QxMOcA',
    description: 'Default text to display when no ship from is selected in a dropdown',
  },
});
